const cleaveConfig = {
    numeral: true,
    numeralThousandsGroupStyle: 'thousand',
    numeralDecimalMark: ',',
    delimiter: '.',
    numeralDecimalScale: 2,
    numeralIntegerScale: 15
}


export {
    cleaveConfig
}